var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"expertise-card",class:_vm.active ? 'active' : ''},[_c('div',{staticClass:"check-icon-container"},[_c('img',{staticClass:"check-icon",attrs:{"src":_vm.checkIcon}})]),_vm._v(" "+_vm._s(_vm.expertise)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }